<section class="chat">
  <app-chatroom [currentUserId]="currentUserId" [chatroomId]="chatroomId" [showWelcomeMessage]="false"></app-chatroom>
</section>
